import Link from "next/link";
import Image from "next/image";

const FOOTER_LINKS = [
  {
    heading: "Product",
    links: [
      { label: "Features", href: "/features" },
      { label: "Pricing", href: "/pricing" },
      { label: "Integrations", href: "/integrations" },
      { label: "Changelog", href: "/changelog" },
      { label: "Docs", href: "/docs" },
    ],
  },
  {
    heading: "Company",
    links: [
      { label: "About Us", href: "/about" },
      { label: "Careers", href: "/careers" },
      { label: "Blog", href: "/blog" },
      { label: "Contact", href: "/contact" },
    ],
  },
  {
    heading: "Legal",
    links: [
      { label: "Privacy Policy", href: "/privacy" },
      { label: "Terms of Service", href: "/terms" },
      { label: "Cancellation & Refund", href: "/refund" },
      { label: "Cookie Policy", href: "/cookies" },
    ],
  },
];

const SOCIALS = [
  { label: "Instagram", path: "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" },
  { label: "Twitter", path: "M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" },
  { label: "LinkedIn", path: "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" },
];

export default function Footer() {
  return (
    <footer className="px-6 py-16" style={{ borderTop: "1px solid rgba(201,168,76,0.1)" }} aria-label="Site footer">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <p style={{ fontFamily: "'Cormorant', Georgia, serif", fontSize: "1.5rem", fontWeight: 300, color: "rgba(245,240,232,0.4)" }}>
            Built on Instagram's Official API
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-10 mb-12">
          <div className="col-span-2 sm:col-span-1">
            <div className="flex flex-col items-start">
              <Image src="/squre-logo.png" alt="Aurelius & Co" width={48} height={48} style={{ marginBottom: "1rem" }} />
              <p style={{ fontFamily: "'Montserrat', sans-serif", fontSize: "0.7rem", color: "rgba(245,240,232,0.3)", lineHeight: 1.6, maxWidth: "200px" }}>
                <span style={{ color: "rgba(245,240,232,0.5)" }}>"Aurelius &amp; co"</span> is an Automation Marketing &amp; SaaS company founded by Pareen Kanakhara (Founder &amp; CEO) and supported by{" "}
                <a
                  href="https://in.linkedin.com/in/raithathaharsh"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "rgba(201,168,76,0.5)", textDecoration: "none", borderBottom: "1px solid rgba(201,168,76,0.15)" }}
                >
                  Harsh Raithatha
                </a>
              </p>
            </div>
          </div>

          {FOOTER_LINKS.map((col) => (
            <div key={col.heading}>
              <h3 className="text-xs font-medium uppercase tracking-widest mb-4" style={{ color: "#C9A84C", fontFamily: "'Montserrat', sans-serif" }}>{col.heading}</h3>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link href={link.href} className="text-xs transition-colors duration-200 cursor-pointer" style={{ color: "rgba(245,240,232,0.28)", fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }} onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = "rgba(201,168,76,0.65)"; }} onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = "rgba(245,240,232,0.28)"; }}>
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex items-center gap-4 mb-8">
          {SOCIALS.map((social) => (
            <a key={social.label} href="#" aria-label={social.label} className="w-8 h-8 flex items-center justify-center transition-colors duration-200 cursor-pointer" style={{ border: "1px solid rgba(201,168,76,0.18)", color: "rgba(245,240,232,0.3)" }} onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = "#C9A84C"; (e.currentTarget as HTMLAnchorElement).style.borderColor = "rgba(201,168,76,0.45)"; }} onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = "rgba(245,240,232,0.3)"; (e.currentTarget as HTMLAnchorElement).style.borderColor = "rgba(201,168,76,0.18)"; }}>
              <svg viewBox="0 0 24 24" fill="currentColor" className="w-3.5 h-3.5" aria-hidden="true">
                <path d={social.path} />
              </svg>
            </a>
          ))}
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4" style={{ borderTop: "1px solid rgba(201,168,76,0.07)" }}>
          <p className="text-xs" style={{ color: "rgba(245,240,232,0.18)", fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
            © {new Date().getFullYear()} Aurelius & Co. All rights reserved.
          </p>
          <p className="text-xs" style={{ color: "rgba(245,240,232,0.12)", fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
            Not affiliated with Instagram or Meta Platforms, Inc.
          </p>
        </div>
      </div>
    </footer>
  );
}